module.exports = __webpack_public_path__ + "static/media/ins.11fa41b2.svg";